import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";

type NotesConfirmDialogProps = {
    isOpen: boolean;
    notes: string;
    onConfirm: () => void;
    onCancel: () => void;
};

export const NotesConfirmDialog = ({ isOpen, notes, onConfirm, onCancel }: NotesConfirmDialogProps) => {
    return (
        <Dialog open={isOpen} onClose={onCancel}>
            <DialogTitle>Reparou nas notas desta sessão?</DialogTitle>
            <DialogContent>
                <Typography variant="h6" sx={{ mt: 2, fontStyle: "italic", color: "text.secondary" }}>
                    {notes}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancelar</Button>
                <Button onClick={onConfirm} variant="contained">
                    Continuar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

